export enum EntityType {
    formula = 'formula',
}

export interface GrantRevokeEntityPermissionRequest {
    entity_type: EntityType;
    entity_id: string;
    user_ids: number[];
}
